import { getTenantDetails } from 'utils/utils';
import { performRequestFourth } from 'common/apiHandler';
import apiEndPoints from 'common/apiEndPoints';

export const updateCustomFields = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.customFields}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data, '', true, true);
};
